import RequestService from "@/configurations/AxiosConfig";

const endpoints = {
  securityNotification: 'security-notification',
};

const SecurityNotificationService = {
  createSecurityNotification: (data: FormData) => RequestService.post(endpoints.securityNotification, data),
  getAllSecurityNotifications: () => RequestService.get(endpoints.securityNotification),
  getSecurityNotificationsById: (id: number) => RequestService.get(`${endpoints.securityNotification}/${id}`),
  getSecurityNotificationsByCompanyId: (id: number) => RequestService.get(`${endpoints.securityNotification}/comapnyId/${id}`),
  createTemplate: (data: FormData) => RequestService.post(`${endpoints.securityNotification}/createTemplate`, data),
  updateTemplate: (id: number, data: FormData) => RequestService.patch(`${endpoints.securityNotification}/updateTemplate/${id}`, data),
  getAllTemplates: (companyId: number | string) => RequestService.get(`${endpoints.securityNotification}/getAllTemplates/${companyId}`),
  removeTemplate: (id: number | string, companyId: number | string) => RequestService.patch(`${endpoints.securityNotification}/removeTemplate/${id}/${companyId}`),
  getTemplatesByCompanyId: (companyId: number | string) => RequestService.get(`${endpoints.securityNotification}/byCompanyId/${companyId}`),
};

export default SecurityNotificationService;
